export default __webpack_public_path__ + "static/media/FleetMax_logo_verde.3ccb5602.svg";